import API_ENDPOINTS from '../../endpoints/apiEndpoints';
import apiClient from '../../apiClient';
import { BaseResponse } from '../UtilsInterface';
import {
  QuestionBody,
  QuestionData,
  QuestionsListApiResponse,
} from '../QnaInterfaces';

const QnaService = {
  // 문의 상세 조회
  getQuestionDetail: async (
    questionId: string
  ): Promise<BaseResponse<QuestionData>> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_question_detail(questionId)
      );
      return response.data; // 응답 데이터 반환
    } catch (error) {
      console.error('문의 상세 조회 실패:', error);
      throw error;
    }
  },

  // 문의 수정
  updateQuestion: async (
    questionId: string,
    data: QuestionBody
  ): Promise<BaseResponse<string>> => {
    try {
      const response = await apiClient.put(
        API_ENDPOINTS.put_question_update(questionId),
        data
      );
      return response.data; // 응답 데이터 반환
    } catch (error) {
      console.error('문의 수정 실패:', error);
      throw error;
    }
  },

  // 문의 삭제
  deleteQuestion: async (questionId: string): Promise<void> => {
    try {
      await apiClient.delete(API_ENDPOINTS.delete_question(questionId));
    } catch (error) {
      console.error('문의 삭제 실패:', error);
      throw error;
    }
  },

  // 문의 내역 조회
  getQuestionsList: async (
    page: number,
    size: number,
    keyword?: string,
    questionType?: string
  ): Promise<QuestionsListApiResponse> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_questions_list(page, size, keyword, questionType)
      );
      return response.data; // 응답 데이터 반환
    } catch (error) {
      console.error('문의 내역 조회 실패:', error);
      throw error;
    }
  },

  // 문의 사항 등록
  createQuestion: async (data: QuestionBody): Promise<BaseResponse<string>> => {
    try {
      const response = await apiClient.post(
        API_ENDPOINTS.post_question_create(),
        data
      );
      return response.data; // 응답 데이터 반환
    } catch (error) {
      console.error('문의 사항 등록 실패:', error);
      throw error;
    }
  },
};

export default QnaService;
